module.exports = __webpack_public_path__ + "img/元素4.e549fa14.png";